import TransactionTypeDetails from "./transaction-type-details.jsx";
import TransactionDocumentDetails from "./transaction-document-detail.jsx";

export { TransactionDocumentDetails };
export default TransactionTypeDetails;